<template>
    <button
        :type="buttonType"
        :disabled="isDisabled"
        :class="[
            'flex justify-center items-center font-oceanside transition-all duration-300 ease-in font-semibold',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
        ]"
    >
        <slot /> {{ tooltipText }}
    </button>
</template>

<script>
    export default {
        props: {
            tooltipText: {
                type: String,
                default: null,
            },
            buttonType: {
                type: String,
                default: 'button',
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
